<template>
	<div>
		<div class="row content-header">
			<div class="content-header-left mb-2 col-md-9 col-12">
				<div class="row breadcrumbs-top">
					<div class="col-12">
						<h2 class="content-header-title float-left pr-1 mb-0">
							<feather-icon icon="ArrowLeftIcon" size="24" class="mr-2" @click="goBack" />
							Egg Production Entry
						</h2>
						<div class="breadcrumb-wrapper">
							<ol class="breadcrumb">
								<li class="breadcrumb-item active">
									<span aria-current="location"> Add </span>
								</li>
							</ol>
						</div>
					</div>
				</div>
			</div>
		</div>
		<validation-observer ref="simpleRules">
			<b-form action="apps-purchase" method="post" @submit="addEggProduction">
				<b-card>
					<!-- <div class="d-flex justify-content-end mb-0 mt-2 mr-2">
						<b-button variant="primary"> Total Alive Birds : {{ this.total_chick ? total_chick : 0 }} </b-button>
					</div> -->
					<b-row>
						<b-col md="6">
							<b-form-group>
								<template v-slot:label> Date <span class="text-danger">*</span> </template>
								<validation-provider #default="{ errors }" name="Entry Date" :rules="{ required: true }">
									<b-form-datepicker
										v-model="FormData.entry_date"
										menu-class="w-100"
										calendar-width="100%"
										class="mb-1"
									/>
									<small class="text-danger">{{ errors[0] }}</small>
								</validation-provider>
							</b-form-group>
						</b-col>
						<b-col md="6">
							<b-form-group>
								<template v-slot:label> No. of Egg Produced<span class="text-danger">*</span> </template>
								<div class="form-label-group">
									<validation-provider #default="{ errors }" name="No. of Egg Produced" rules="required">
										<b-form-input
											v-model="FormData.egg_produced"
											placeholder="No. of Egg Produced"
											type="text"
											name="total_stock"
										/>
										<small class="text-danger">{{ errors[0] }}</small>
									</validation-provider>
								</div>
							</b-form-group>
						</b-col>
						<b-col md="6">
							<b-row>
								<b-col md="4">
									<b-form-group>
										<template v-slot:label> Jumbo Eggs <span class="text-danger">*</span> </template>
										<div class="form-label-group">
											<!-- <validation-provider #default="{ errors }" name="Grade A" rules="required"> -->
											<b-form-input
												v-model="FormData.jumbo_eggs"
												placeholder="Jumbo Eggs"
												type="text"
												name="jumbo_eggs"
											/>
											<!-- <small class="text-danger">{{ errors[0] }}</small>
											</validation-provider> -->
										</div>
									</b-form-group>
								</b-col>
								<b-col md="4">
									<b-form-group>
										<template v-slot:label> Standard Eggs </template>
										<div class="form-label-group">
											<!-- <validation-provider #default="{ errors }" name="Grade A" rules="required"> -->
											<b-form-input
												v-model="FormData.standard_eggs"
												placeholder="Standard Eggs"
												type="text"
												name="standard_eggs"
											/>
											<!-- <small class="text-danger">{{ errors[0] }}</small>
											</validation-provider> -->
										</div>
									</b-form-group>
								</b-col>
								<b-col md="4">
									<b-form-group>
										<template v-slot:label> Pullet Eggs </template>
										<div class="form-label-group">
											<!-- <validation-provider #default="{ errors }" name="Grade A" rules="required"> -->
											<b-form-input
												v-model="FormData.pullet_eggs"
												placeholder="Pullet Eggs"
												type="text"
												name="pullet_eggs"
											/>
											<!-- <small class="text-danger">{{ errors[0] }}</small>
											</validation-provider> -->
										</div>
									</b-form-group>
								</b-col>
							</b-row>
						</b-col>
						<b-col md="6">
							<b-form-group>
								<template v-slot:label> Broken Eggs <span class="text-danger">*</span> </template>
								<div class="form-label-group">
									<validation-provider #default="{ errors }" name="broken_eggs" rules="required">
										<b-form-input
											v-model="FormData.broken_eggs"
											placeholder="Broken Eggs"
											type="text"
											name="broken_eggs"
										/>
										<small class="text-danger">{{ errors[0] }}</small>
									</validation-provider>
								</div>
							</b-form-group>
						</b-col>
						<b-col md="6">
							<b-form-group>
								<template v-slot:label> Malformed Eggs <span class="text-danger">*</span> </template>
								<div class="form-label-group">
									<validation-provider #default="{ errors }" name="malfromed_eggs" rules="required">
										<b-form-input
											v-model="FormData.malfromed_eggs"
											placeholder="Malformed Eggs"
											type="text"
											name="malfromed_eggs"
										/>
										<small class="text-danger">{{ errors[0] }}</small>
									</validation-provider>
								</div>
							</b-form-group>
						</b-col>
						<b-col md="6">
							<b-form-group>
								<template v-slot:label> Rejected Eggs <span class="text-danger">*</span> </template>
								<div class="form-label-group">
									<validation-provider #default="{ errors }" name="rejected_eggs" rules="required">
										<b-form-input
											v-model="FormData.rejected_eggs"
											placeholder="Rejected Eggs "
											type="text"
											name="rejected_eggs"
										/>
										<small class="text-danger">{{ errors[0] }} </small>
									</validation-provider>
								</div>
							</b-form-group>
						</b-col>
						<!-- <b-col md="6">
							<b-form-group>
								<template v-slot:label> Useable Eggs </template>
								<div class="form-label-group">
									<validation-provider #default="{ errors }" name="usable_eggs" rules="required">
										<b-form-input
											:value="
												FormData.broken_eggs + FormData.malfromed_eggs + FormData.rejected_eggs
											"
											placeholder="Useable Eggs"
											type="text"
											name="usable_eggs"
											disabled
										/>
										<small class="text-danger">{{ errors[0] }}</small>
									</validation-provider>
								</div>
							</b-form-group>
						</b-col> -->

						<!-- submit and reset -->
						<b-col md="12">
							<b-button type="submit" variant="primary" value="Submit" class="mr-1 mb-3"> Submit </b-button>
						</b-col>
					</b-row>
				</b-card>
			</b-form>
		</validation-observer>
	</div>
</template>

<script>
import Logo from "@core/layouts/components/Logo.vue";

import * as Vue from "vue";
import axios from "axios";

import { BASE_URL } from "@core/common/constants";
import moment from "moment";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import axiosIns from "@/libs/axios";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required, email } from "@validations";
export default {
	components: {
		flatPickr,
		vSelect,
		Logo,
	},

	data() {
		return {
			required,
			selected: null,
			FormData: {
				egg_produced: null,
				grades: null,
				broken_eggs: null,
				malfromed_eggs: null,
				rejected_eggs: null,
				usable_eggs: null,
			},
		};
	},
	created: function () {
		this.flockId = this.$route.params.flockId;
		this.farmId = this.$route.params.farmId;
		this.shedId = this.$route.params.shedId;
	},
	methods: {
		goBack() {
			this.$router.push(`/apps/manage-farm/${this.farmId}/shed/${this.shedId}/data-entry/${this.flockId}`);
		},
		addEggProduction(e) {
			e.preventDefault();
			this.$refs.simpleRules.validate().then((success) => {
				if (success) {
					var data = new FormData();
					data.append("egg_produced", this.FormData.egg_produced);
					data.append("jumbo_eggs", this.FormData.jumbo_eggs);
					data.append("pullet_eggs", this.FormData.pullet_eggs);
					data.append("standard_eggs", this.FormData.standard_eggs);
					data.append("broken_eggs", this.FormData.broken_eggs);
					data.append("malfromed_eggs", this.FormData.malfromed_eggs);
					data.append("rejected_eggs", this.FormData.rejected_eggs);
					data.append("entry_date", this.FormData.entry_date);
					// data.append("usable_eggs", this.FormData.usable_eggs);
					axiosIns
						.post(`web/farm/${this.farmId}/shed/${this.shedId}/flock/${this.flockId}/egg-production-entry`, data)
						.then((res) => {
							this.$toast({
								component: ToastificationContent,
								position: "top-right",
								props: {
									icon: "CoffeeIcon",
									variant: "success",
									text: `Data Successfully Added `,
								},
							});
							this.$router.push({
								path: `/apps/manage-farm/${this.farmId}/shed/${this.shedId}/data-entry/${this.flockId}`,
							});
						})
						.catch((error) => {
							const responseData = error.response?.data;
							let text = "Something went wrong. Please try again.";
							if (responseData?.errors) {
								text = Object.values(responseData.errors).flat().toString(",");
							} else if (responseData?.message) {
								text = responseData.message;
							}

							this.$toast({
								component: ToastificationContent,
								position: "top-right",
								props: {
									icon: "CoffeeIcon",
									variant: "danger",
									text,
								},
							});
						});
				}
			});
		},
	},
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
.invoice-add-wrapper {
	.add-new-client-header {
		padding: $options-padding-y $options-padding-x;
		color: $success;

		&:hover {
			background-color: rgba($success, 0.12);
		}
	}
}
</style>

<style lang="scss" scoped>
@import "~@core/scss/base/pages/app-invoice.scss";
@import "~@core/scss/base/components/variables-dark";
